import { FC } from 'react'
import { Colors } from 'src/components/theme'
import { WidgetCard } from 'src/v2/components/widget-card'
import { PropertyRecordsParcelContent } from 'src/v2/views/owner-reveal/insights/parcel-insights/property-records/parcel/content'

export const ParcelWidget: FC = () => {
  return (
    <WidgetCard
      id="parcel"
      title="Parcel"
      headerBgColor={Colors.primaryGreen700}
      headerTextColor={Colors.textWhite}
      sections={[
        {
          content: <PropertyRecordsParcelContent />,
        },
      ]}
    />
  )
}
